import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Div from 'components/Div'
import { pixelise } from 'tools/style'
import 'lazysizes'

const Image = styled.img.attrs((props) => ({
  className: props.lazy ? 'lazyload' : ''
}))`
  ${props => props.height ? `height: ${pixelise(props.height)};` : ''}
  ${props => props.width ? `width: ${pixelise(props.width)};` : ''}
  ${props => props.objectFit ? `object-fit: ${props.objectFit};` : ''}
`
Image.propTypes = {
  height: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  width: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  objectFit: PropTypes.oneOf([ 'fill', 'contain', 'cover', 'none', 'scale-down' ])
}

const RatioImageContainer = styled(Div)`
  position: relative;
  width: 100%;
  padding-top: ${props => props.ratio * 100}%;
  overflow: hidden;
`
RatioImageContainer.propTypes = {
  ratio: PropTypes.number
}

const RatioImageElement = styled(Image).attrs(() => ({
  objectFit: 'cover'
}))`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`

export const RatioImage = ({ ratio = 1, className, ...props }) => (
  <RatioImageContainer ratio={ratio} className={className}>
    <RatioImageElement {...props} />
  </RatioImageContainer>
)
RatioImage.propTypes = {
  ratio: PropTypes.number
}

export default Image
